import { useEffect, useState } from 'react'

/**
 * Vrací aktuální čas a překresluje komponentu, dokud je `active`.
 *
 * Slouží JEN k zobrazení časomíry. Doménový stav se tím nemění —
 * uplynulý čas se vždy dopočítá z `questionStartedAt`.
 *
 * Původní aplikace naopak držela čítač ve stavu a inkrementovala ho
 * v `setInterval` přes zastaralý `this.state`, takže hodnota přetékala
 * mezi otázkami a časová penalizace padala neprávem.
 */
export function useNow(active: boolean, intervalMs = 500): number {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    if (!active) return undefined

    setNow(Date.now())
    const id = window.setInterval(() => setNow(Date.now()), intervalMs)

    // Úklid při každé změně fáze — intervaly se nikdy nekumulují
    return () => window.clearInterval(id)
  }, [active, intervalMs])

  return now
}
